"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableGroup = void 0;
const calcDepthForNode_1 = __importDefault(require("@opsbase/lib-data-element/helpers/calcDepthForNode"));
const findGroupByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByKey"));
const calcUniqueKeyForViewField_1 = __importDefault(require("@opsbase/lib-data-viewfield/helpers/calcUniqueKeyForViewField"));
const splitTitle_1 = __importDefault(require("@opsbase/lib-general/utils/splitTitle"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useDataTreeActions_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTreeActions"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const calcIsExpanded_1 = __importDefault(require("@opsbase/web-dvl/helpers/calcIsExpanded"));
const useDVL_1 = __importDefault(require("@opsbase/web-dvl/useDVL"));
const ChevronRightIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronRightIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const DVLTableCell_1 = __importDefault(require("../DVLTableCell"));
const DVLTableRowHeader_1 = __importDefault(require("../DVLTableRow/DVLTableRowHeader"));
const DVLTableRowPager_1 = __importDefault(require("../DVLTableRow/DVLTableRowPager"));
const DVLTableGroupAggCell_1 = __importDefault(require("./DVLTableGroupAggCell"));
const makeMyClasses = (depth, headerHeight, isLoading, isExpanded, isEmpty, color, backgroundColor) => ({
    header: {
        borderBottom: isExpanded ? `1px solid ${lib_palette_1.default.LineGrey.main}` : undefined,
        position: 'sticky',
        top: 48 * depth + headerHeight,
        backgroundColor: backgroundColor.main,
        zIndex: 20 - depth,
    },
    chevron: {
        borderRadius: '50%',
        backgroundColor: isLoading ? lib_palette_1.default.secondary.main : 'transparent',
        animation: isLoading ? 'spin 1s linear infinite' : undefined,
        transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
        transition: 'transform 0.3s, background-color 0.3s',
    },
    preTitle: {
        fontSize: 12,
        color: isEmpty ? undefined : lib_palette_1.default.GreyBlue.main,
    },
});
function DVLTableGroup(props) {
    var _a, _b, _c;
    const { nodeKey } = props;
    const { headerHeight } = (0, useDVL_1.default)();
    const dt = (0, useDataTree_1.default)();
    const view = (0, useView_1.default)(dt.viewId);
    const node = dt.nodesByKey.get(nodeKey);
    const { toggleExpandNode } = (0, useDataTreeActions_1.default)();
    const group = node.group;
    const totalCount = dt.totalCountForNode.get(node) || 0;
    const count = ((_b = (_a = node === null || node === void 0 ? void 0 : node.itemCollection) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) || 0;
    const isItemCollection = !!(node === null || node === void 0 ? void 0 : node.itemCollection);
    const hasPaging = isItemCollection && count < totalCount;
    const isEmpty = totalCount === 0;
    const isLoading = ((_c = node === null || node === void 0 ? void 0 : node.itemCollection) === null || _c === void 0 ? void 0 : _c.loading) || false;
    const isExpanded = (0, calcIsExpanded_1.default)(view, node);
    const showPager = hasPaging && node.expanded;
    const { title, preTitle } = (0, splitTitle_1.default)(group === null || group === void 0 ? void 0 : group.title);
    const color = group === null || group === void 0 ? void 0 : group.color;
    const titleColor = isEmpty ? 'lightgrey' : undefined;
    const depth = (0, react_1.useMemo)(() => {
        return (0, calcDepthForNode_1.default)(node);
    }, [node]);
    const backgroundColor = depth === 1 ? lib_palette_1.default.WhiteSmoke : lib_palette_1.default.White;
    const myCss = (0, web_css_1.default)(makeMyClasses, [
        depth,
        headerHeight,
        isLoading,
        isExpanded,
        isEmpty,
        color,
        backgroundColor,
    ]);
    const handleClick = (0, react_1.useCallback)(() => {
        toggleExpandNode(node);
    }, [node, toggleExpandNode]);
    const header = (0, react_1.useMemo)(() => {
        const pager = showPager ? (react_1.default.createElement("div", { style: { position: 'relative' } },
            react_1.default.createElement("div", { style: { position: 'absolute', right: 2, bottom: 0 } },
                react_1.default.createElement(DVLTableRowPager_1.default, { nodeKey: nodeKey })))) : undefined;
        return (react_1.default.createElement(DVLTableRowHeader_1.default, { nodeKey: nodeKey, backgroundColor: backgroundColor, childrenBelow: pager },
            react_1.default.createElement(DVLTableCell_1.default, { isFirstCol: true },
                react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start', onClick: isEmpty ? undefined : handleClick },
                    react_1.default.createElement("div", { key: nodeKey + 'expander', className: myCss.chevron },
                        react_1.default.createElement(ChevronRightIcon_1.default, { color: isEmpty
                                ? lib_palette_1.default.BackgroundGrey
                                : isLoading
                                    ? lib_palette_1.default.White
                                    : lib_palette_1.default.GreyBlue })),
                    react_1.default.createElement(Text_1.default, { color: titleColor, variant: depth === 0 ? 'h2' : 'h3', weight: true },
                        !!preTitle && (react_1.default.createElement("span", { className: myCss.preTitle }, preTitle + ' > ')),
                        title)))));
    }, [
        backgroundColor,
        depth,
        handleClick,
        isEmpty,
        isLoading,
        myCss,
        nodeKey,
        preTitle,
        showPager,
        title,
        titleColor,
    ]);
    return (0, react_1.useMemo)(() => {
        const visibleFields = view.fields
            .filter(field => !field.hidden)
            .filter(field => !(0, findGroupByKey_1.default)(view.groupBys, field.key.toString()))
            .slice(0, view.maxVisibleFields);
        return (react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.header } },
            header,
            react_1.default.createElement(Horizontal_1.default, { centered: true }, visibleFields.map((field, idx) => idx > 0 && (react_1.default.createElement(DVLTableGroupAggCell_1.default, { nodeKey: nodeKey, key: (0, calcUniqueKeyForViewField_1.default)(field), field: field, colIdx: idx, isLastCol: idx === visibleFields.length - 1 }))))));
    }, [view, myCss, header, nodeKey]);
}
exports.DVLTableGroup = DVLTableGroup;
exports.default = DVLTableGroup;
